// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"d7fe23d0","633":"d46666fe","950":"23f8fd39"}[chunkId] + ".chunk.css";
};